var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-autocomplete',_vm._g(_vm._b({attrs:{"value":_vm.val,"items":_vm.items,"rules":_vm.rules}},'w-autocomplete',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }